var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0117 3.15199L13.1798 1.98386C13.825 1.33871 14.871 1.33871 15.5161 1.98386C16.1612 2.629 16.1612 3.67498 15.5161 4.32013L14.348 5.48826M12.0117 3.15199L7.65015 7.51354C6.77906 8.38463 6.34351 8.82018 6.04693 9.35092C5.75035 9.88167 5.45196 11.1349 5.16663 12.3333C6.36503 12.048 7.61829 11.7496 8.14903 11.453C8.67978 11.1564 9.11533 10.7209 9.98642 9.84981L14.348 5.48826M12.0117 3.15199L14.348 5.48826",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9C16 12.5355 16 14.3033 14.9016 15.4016C13.8033 16.5 12.0355 16.5 8.5 16.5C4.96447 16.5 3.1967 16.5 2.09835 15.4016C1 14.3033 1 12.5355 1 9C1 5.46447 1 3.6967 2.09835 2.59835C3.1967 1.5 4.96447 1.5 8.5 1.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChatIcon);
export default __webpack_public_path__ + "static/media/new-chat-icon.220ea76b2ca5f3c611a31a9dcbd32ba1.svg";
export { ForwardRef as ReactComponent };